import { ErrorState, LoadingState } from '@cinesend/ui-kit'

const QueryState = ({ isLoading = false, error, loadingClassName, children }) => {
  if (isLoading) return <LoadingState className={['justify-center', loadingClassName].filter(Boolean).join(' ')} />
  if (error) return <ErrorState message={error.message ?? 'An error occurred. Please contact customer support.'} />

  return children
}

export default QueryState
